import { useMedicationRequestById, useSuspenseMedicationRequestById } from '@/services/medicationRequests'
import { useParams } from 'react-router-dom'
import usePrepareNextRequest from './usePrepareNextRequest'
import { useLockItemById } from '@/services/useLockItem'
import { shouldLockOpenedMedRequest } from '@/lib/med-requests'

export const useCurrentMedication = (enabled?: boolean, customId?: string, prepareNext = true) => {
  const { id } = useParams<{ id: string }>()

  const medRequest = useMedicationRequestById(customId ?? id!, enabled)
  const lockMedRequest = medRequest?.data ? shouldLockOpenedMedRequest(medRequest.data) : false

  useLockItemById(customId ?? id!, !!(medRequest?.data && !medRequest?.data?.locked && enabled) && lockMedRequest)
  usePrepareNextRequest(enabled && prepareNext)

  if (!id) {
    throw new Error('No ID provided')
  }

  return medRequest
}

export const useSuspenseCurrentMedication = () => {
  const { id } = useParams<{ id: string }>()

  if (!id) {
    throw new Error('No ID provided')
  }
  const medRequest = useSuspenseMedicationRequestById(id)

  const lockMedRequest = medRequest.data ? shouldLockOpenedMedRequest(medRequest.data) : false

  useLockItemById(id, !!(medRequest.data && !medRequest.data.locked) && lockMedRequest)
  usePrepareNextRequest()

  return medRequest
}
